import '@mrhenry/wp--bugsnag-config';

import { MrTabs, MrCarousel, MrMenu } from '@mrhenry/wp--mr-interactive';

import './modules/ga-consent';
import './modules/mr-accordion';
import './modules/mr-blocked-content';
import './modules/mr-input-sink';
import './modules/mr-navigation-overlay';

customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-tabs', MrTabs );
customElements.define( 'mr-menu', MrMenu );
